import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyAgentModalService {

  private selectedCompanyAgentSubject = new BehaviorSubject<any>(null);
  public selectedCompanyAgent$ = this.selectedCompanyAgentSubject.asObservable();

  constructor() { }

  setSelectedCompanyAgent(companyAgent: any): void {
    this.selectedCompanyAgentSubject.next(companyAgent);
  }

  getSelectedCompanyAgent(): any | null {
    return this.selectedCompanyAgentSubject.value;
  }

  clearSelectedCompanyAgent(): void {
    this.selectedCompanyAgentSubject.next(null);
  }
}

